module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/shop_studiosuns_02-29b6e85c13c6a13986d9508df06f5b33.png";